import { precio, porcentaje } from './importes';

export function cantidadDisplay(descuento) {
  if (descuento.tipo === 'fixed') {
    return precio(descuento.cantidad);
  }
  return porcentaje(descuento.cantidad);
}
